import arqueroImg from '../assets/arquero01.jpg';
import delanteroImg from '../assets/delantero.jpg';
import laRomaImg from '../assets/La Roma.jpg';
import mediocampistaImg from '../assets/mediocampista.jpg';
import jugadoraDefImg from '../assets/jugadora defensora.jpg';
import jugadoraDelImg from '../assets/jugadora delantera.jpg';
import jugadoraMedImg from '../assets/jugadora mediocampo.jpg';

export const CATEGORIES = [
  { id: 'jugador', name: 'Player', icon: 'User' },
  { id: 'equipo', name: 'Equipo', icon: 'Users' }
];

export const POSITIONS = [
  'Arquero',
  'Defensor',
  'Mediocampista',
  'Delantero'
];

export const localizePosition = (pos, gender) => {
  if (!pos) return pos;
  const g = gender?.toLowerCase();
  if (g === 'mujer' || g === 'femenino') {
    const map = {
      'Arquero': 'Arquera',
      'Defensor': 'Defensora',
      'Delantero': 'Delantera',
      'Mediocampista': 'Mediocampista'
    };
    // Handle comma separated positions if any
    if (pos.includes(',')) {
      return pos.split(', ').map(p => map[p] || p).join(', ');
    }
    return map[pos] || pos;
  }
  return pos;
};

export const MOCK_DATA = [
  {
    id: 'm1',
    type: 'jugador',
    name: 'Sofi G.',
    position: 'Delantera',
    location: 'General Roca',
    rating: 4.9,
    reviews: 12,
    image: jugadoraDelImg,
    specialty: 'F5 / F7',
    isAvailable: true,
    isMixedAvailable: true,
    gender: 'Mujer',
    attendanceRate: 100,
    matches_played: 12,
    matches_total: 12,
    xp: 3200
  },
  {
    id: 'm2',
    type: 'jugador',
    name: 'Nico T.',
    position: 'Delantero',
    location: 'Stefenelli',
    rating: 4.7,
    reviews: 10,
    image: delanteroImg,
    specialty: 'F11 / F7',
    isAvailable: true,
    isMixedAvailable: true,
    gender: 'Hombre',
    attendanceRate: 83,
    matches_played: 10,
    matches_total: 12,
    xp: 2150
  },
  {
    id: 'm3',
    type: 'jugador',
    name: 'Marta R.',
    position: 'Defensora',
    location: 'Barrio Bagliani',
    rating: 4.8,
    reviews: 22,
    image: jugadoraDefImg,
    specialty: 'F7 / F11',
    isAvailable: true,
    isMixedAvailable: true,
    gender: 'Mujer',
    attendanceRate: 100,
    xp: 2800
  },
  {
    id: 'm4',
    type: 'jugador',
    name: 'Franco M.',
    position: 'Arquero',
    location: 'Centro, Roca',
    rating: 5.0,
    reviews: 6,
    image: arqueroImg,
    specialty: 'F5 / F7',
    isAvailable: true,
    isMixedAvailable: true,
    gender: 'Hombre',
    attendanceRate: 50,
    matches_played: 6,
    matches_total: 12,
    xp: 4100
  },
  {
    id: 'm5',
    type: 'jugador',
    name: 'Luli F.',
    position: 'Mediocampo',
    location: 'Gral. Roca',
    rating: 4.6,
    reviews: 11,
    image: jugadoraMedImg,
    specialty: 'F5 / F7',
    isAvailable: true,
    isMixedAvailable: true,
    gender: 'Mujer',
    attendanceRate: 89,
    xp: 1500
  },
  {
    id: 'm6',
    type: 'jugador',
    name: 'Santi V.',
    position: 'Mediocampista',
    location: 'J.J. Gómez',
    rating: 4.8,
    reviews: 26,
    image: mediocampistaImg,
    specialty: 'F5 / F11',
    isAvailable: true,
    isMixedAvailable: true,
    gender: 'Hombre',
    attendanceRate: 97,
    xp: 2900
  },
  {
    id: 'm7',
    type: 'equipo',
    name: 'La Roma FC',
    position: 'Busca Rival',
    location: 'Barrio Bagliani',
    rating: 4.5,
    reviews: 8,
    image: laRomaImg,
    specialty: 'Fútbol 5 / 7',
    teamCategory: 'Masculino',
    isAvailable: true,
    xp: 1800
  }
];

